import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Grid } from '@/components/Grid';

export const HeaderWrapper = styled(Box)`
  text-align: center;
  padding: ${({ theme }) => theme.spacing(2, 2, 3)};

  ${({ theme }) => css`
    ${theme.media.md.up} {
      padding: ${({ theme }) => theme.spacing(4, 4, 4)};
    }
  `}
`;

export const Services = styled(Grid)`
  grid-template-columns: repeat(3, 1fr);
  width: 100%;
  margin: 0 auto;

  ${({ theme }) => css`
    background-color: ${theme.colors.lightGrey};

    ${theme.media.md.up} {
      grid-template-columns: 1fr 1fr;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      gap: ${theme.spacing(4)};
    }
  `}
`;
